const labels = [
  { limit: 1024, precision: 0, label: 'size.bytes'},
  { limit: 1024 * 1024, precision: 1, label: 'size.kbytes'},
  { limit: Infinity, precision: 2, label: 'size.mbytes'}
];

export default (size) => {
  let index = 0;
  for (; index < labels.length; ++index) {
    if (size < labels[index].limit) {
      break;
    }
  }

  index = Math.min(index, labels.length - 1);

  const base = (index == 0 ? 1 : labels[index - 1].limit);
  const info = labels[index];

  return {
    size: (size / base).toFixed(info.precision),
    label: info.label
  }
};
